import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsx("path", _objectSpread({
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9761 8.6391L14.8461 6L16 2.5L17.1538 6L18.0239 8.63909C18.0239 8.6391 18.0239 8.63911 18.0239 8.63912\n       C18.1025 8.87758 18.1355 9.12871 18.1212 9.37939L17.3608 22.686L17.2857 24H19L18.4026 25.3939\n       C18.245 25.7616 17.8835 26 17.4835 26H17L16.6667 29H15.3333L15 26H14.5165\n       C14.1165 26 13.755 25.7616 13.5974 25.3939L13 24H14.7143L14.6232 22.4067L13.8788 9.37938\n       C13.8663 9.16004 13.89 8.94034 13.9488 8.7291C13.9572 8.69892 13.9663 8.66891 13.9761 8.6391ZM2 8\n       L5.89443 9.94721C6.572 10.286 7 10.9785 7 11.7361V18L5.60818 16.4342\n       C3.90229 14.5151 2.75705 12.1638 2.29773 9.6375L2 8ZM30 8L26.1056 9.94721C25.428 10.286 25 10.9785 25 11.7361\n       V18L26.3918 16.4342C28.0977 14.5151 29.243 12.1638 29.7023 9.6375L30 8ZM12.7403 6H10C9.44772 6 9 6.44771 9 7\n       V16.2331C9 18.6306 10.4236 20.7747 12.581 21.724L11.8821 9.49349\n       C11.8534 8.99213 11.9194 8.48985 12.0767 8.01292L12.7403 6ZM19.4074 21.9268C21.5789 20.9764 23 18.8249 23 16.4309\n       V7C23 6.44772 22.5523 6 22 6H19.2597L19.9233 8.0129C20.0805 8.48984 20.1466 8.99212 20.1179 9.4935L19.4074 21.9268Z"
  }, args));
};
var ViewBox = "0 0 32 32";
var _FWFrontline = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "white" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 32 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_FWFrontline.displayName = "FWFrontline";
var FWFrontline = withSubcomponents(_FWFrontline, {
  Path: Path,
  ViewBox: ViewBox
});
export { FWFrontline };